/** Checkbox UI state for the Quicksight category (dashboard IDs, not reporting enums). */
export type QuicksightDashboardSelection = Readonly<{
  checkedValues: ReadonlyArray<string>;
  everyChecked: boolean;
  someChecked: boolean;
  selectedCount: number;
  totalCount: number;
}>;

/** Derives card header counts and tri-state group checkbox from known dashboard IDs. */
export const getQuicksightDashboardSelection = (
  dashboardIds: ReadonlyArray<string>,
  checkedValues: ReadonlyArray<string>,
): QuicksightDashboardSelection => {
  const totalCount = dashboardIds.length;
  const selectedCount = dashboardIds.filter(id =>
    checkedValues.includes(id),
  ).length;

  return {
    checkedValues,
    everyChecked:
      totalCount > 0 &&
      dashboardIds.every(dashboardId => checkedValues.includes(dashboardId)),
    someChecked: dashboardIds.some(dashboardId =>
      checkedValues.includes(dashboardId),
    ),
    selectedCount,
    totalCount,
  };
};

/**
 * When false, user-detail header should not show granted/not-granted totals yet
 * (avoids a jump from enum-only counts to enum + dashboard counts).
 *
 * Pass react-query `isLoading` only — not `isFetching`, so background refetches
 * do not flash the header placeholder.
 */
export const isQuicksightHeaderStatsReady = (
  email: string,
  isInitialLoad: boolean,
): boolean => !email || !isInitialLoad;
